import React from "react";
import { endOfDay, startOfDay } from "date-fns";
import { currencyFormatterShort } from "@common/helpers/currency";
import {
    ENTITY_TRANSACTIONS_THRESHOLD,
    FLAT_RATE_PLANS,
    flatRatePlanNames,
    TRIAL_LENGTH_DAYS,
} from "@common/flatRateBilling";
import { TransactionSortValue } from "./useSort";

export function isSortedByDate(currentSort: TransactionSortValue): boolean {
    return (
        currentSort === TransactionSortValue.DATE_ASC ||
        currentSort === TransactionSortValue.DATE_DESC
    );
}

export function transactionsMaybeAfterLimitReached(
    filtersEndDate?: Date,
    limitReachedDate?: Date | null,
) {
    return Boolean(
        !filtersEndDate ||
        (limitReachedDate &&
            endOfDay(limitReachedDate) < endOfDay(filtersEndDate)),
    );
}

export function transactionsMaybeBeforeBookkeepingStart(
    filtersStartDate?: Date,
    bookkeepingStartDate?: Date | null,
) {
    return Boolean(
        !filtersStartDate ||
        (bookkeepingStartDate &&
            startOfDay(bookkeepingStartDate) > startOfDay(filtersStartDate)),
    );
}

interface GetCTAHeaderParams {
    isTrialing: boolean;
    usageLimit: number;
    currentPlan: FLAT_RATE_PLANS;
}

export function getHistoricalDataContentHeader({
    isTrialing,
    usageLimit,
    currentPlan,
}: GetCTAHeaderParams) {
    if (isTrialing) {
        return (
            <>
                <h3>
                    Your{" "}
                    <span className="text-blue-600">
                        {flatRatePlanNames[currentPlan]}
                    </span>{" "}
                    Trial includes up to 4 months of transactions.
                </h3>

                <p>
                    Start your subscription now to get full access to your data.
                </p>
            </>
        );
    }

    return (
        <>
            <h3>
                You've reached the {currencyFormatterShort.format(usageLimit)}{" "}
                expense limit
            </h3>
            <p>Upgrade now for full access to historical data</p>
        </>
    );
}

export function getNewDataContentHeader({ usageLimit }: GetCTAHeaderParams) {
    return (
        <>
            <h3>
                You've reached the {currencyFormatterShort.format(usageLimit)}{" "}
                expense limit
            </h3>

            <p>
                Start your {TRIAL_LENGTH_DAYS}-day trial now to access recent
                data
            </p>
        </>
    );
}

export function getTransactionLimitReachedContentHeader() {
    return (
        <>
            <h3>
                You've reached the {ENTITY_TRANSACTIONS_THRESHOLD} transaction
                limit
            </h3>

            <p>Upgrade now to continue using Kick</p>
        </>
    );
}
